import { ShieldCheck, Lock, Star } from 'lucide-react';
import { useLanguage } from '@/i18n/LanguageContext';

const testimonials = [
  { text: 'Fast and accurate translation. Very useful for my daily work!', author: 'Sarah K.', role: 'Business Owner' },
  { text: 'Best translator I have used. Supports all the languages I need.', author: 'Marco L.', role: 'Freelancer' },
];

const TrustSection = () => {
  const { t } = useLanguage();

  return (
    <section className="py-6 sm:py-8">
      {/* Trust badges */}
      <div className="flex flex-wrap items-center justify-center gap-4 sm:gap-6 mb-6 sm:mb-8">
        <div className="flex items-center gap-2 text-xs sm:text-sm text-muted-foreground">
          <Lock className="h-4 w-4 text-primary" />
          <span>{t('trust.securePrivate')}</span>
        </div>
        <div className="flex items-center gap-2 text-xs sm:text-sm text-muted-foreground">
          <ShieldCheck className="h-4 w-4 text-primary" />
          <span>{t('trust.dataProtected')}</span>
        </div>
        <div className="flex items-center gap-2 text-xs sm:text-sm text-muted-foreground">
          <ShieldCheck className="h-4 w-4 text-primary" />
          <span>{t('trust.noDataStored')}</span>
        </div>
      </div>

      {/* Testimonials */}
      <div className="grid sm:grid-cols-2 gap-4 max-w-2xl mx-auto">
        {testimonials.map((t, i) => (
          <div key={i} className="rounded-xl border bg-card p-4 sm:p-5 shadow-sm hover:shadow-md transition-shadow">
            <div className="flex gap-0.5 mb-2">
              {Array.from({ length: 5 }).map((_, j) => (
                <Star key={j} className="h-3.5 w-3.5 fill-primary text-primary" />
              ))}
            </div>
            <p className="text-sm text-foreground leading-relaxed mb-3">"{t.text}"</p>
            <div className="text-xs text-muted-foreground">
              <span className="font-medium text-foreground">{t.author}</span> · {t.role}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default TrustSection;
